import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable({ providedIn: 'root' })
export class DeviationService extends EntityCollectionServiceBase<any> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Deviation', serviceElementsFactory);
    }
}
